import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#C7D0D9"
      d="M74.415 88.868a5.51 5.51 0 0 1-5.512 5.512H30.32a5.51 5.51 0 0 1-5.512-5.512V39.262a5.51 5.51 0 0 1 5.512-5.512h28.033c1.461 0 2.862.581 3.895 1.613l10.553 10.553a5.5 5.5 0 0 1 1.613 3.895z"
    />
    <path
      fill="#8F9BA8"
      d="M83.792 80.6a5.51 5.51 0 0 1-5.512 5.512H39.697a5.51 5.51 0 0 1-5.512-5.512V30.994a5.51 5.51 0 0 1 5.512-5.512H67.73c1.461 0 2.862.581 3.895 1.613l10.553 10.553a5.5 5.5 0 0 1 1.613 3.895z"
    />
    <path
      fill="#C7D0D9"
      d="M92.06 72.333a5.51 5.51 0 0 1-5.513 5.512H47.965a5.51 5.51 0 0 1-5.512-5.512V22.727a5.51 5.51 0 0 1 5.512-5.512h28.033c1.461 0 2.862.58 3.895 1.613L90.446 29.38a5.5 5.5 0 0 1 1.613 3.895v39.056"
    />
    <path
      fill="#7B8493"
      fillRule="evenodd"
      d="M52.415 35.758a2.25 2.25 0 0 1 2.25-2.25h25.622a2.25 2.25 0 1 1 0 4.5H54.665a2.25 2.25 0 0 1-2.25-2.25M52.415 49.518a2.25 2.25 0 0 1 2.25-2.25h25.622a2.25 2.25 0 1 1 0 4.5H54.665a2.25 2.25 0 0 1-2.25-2.25M52.415 63.278a2.25 2.25 0 0 1 2.25-2.25h25.622a2.25 2.25 0 1 1 0 4.5H54.665a2.25 2.25 0 0 1-2.25-2.25"
      clipRule="evenodd"
    />
    <path fill="#F1F4FA" d="M90.5 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M110.627 14.51a1.5 1.5 0 0 1 0 2.12l-9.993 9.995a1.5 1.5 0 0 1-2.122-2.121l9.993-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M98.512 14.51a1.5 1.5 0 0 1 2.122 0l9.993 9.994a1.501 1.501 0 0 1-2.122 2.12l-9.993-9.993a1.5 1.5 0 0 1 0-2.121"
      clipRule="evenodd"
    />
    <path
      fill="#ACB8C3"
      d="M46.94 106.13a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M11.063 68.797a1.5 1.5 0 0 1 1.5 1.5V84.43a1.5 1.5 0 0 1-3 0V70.297a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M2.496 77.364a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 1 1 0 3H3.996a1.5 1.5 0 0 1-1.5-1.5M19.067 97.13a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconFilesGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconFilesGreyscale);
export default Memo;
